import Loading from '../../components/Loading';
import EmployeeDisplayGrid from './EmployeeDisplayGrid';
import { useEffect, useState } from 'react';
import PriorityQueries from '../admin/PriorityQueries';
import {
  getStoredSelection,
  getStoredProxySelection,
  getStoredAutoScrollSettings,
  storeAutoScrollSettinga,
} from '../../components/form/react-hook-form-components/FilterStorage';
import FilterOptions, { IFilterOptions } from '../FilterOptions';
import SelectedRoles from '../management/employees/roles/SelectedRoles';
import { animateScroll as scroll } from 'react-scroll';
import Checkbox from '@mui/material/Checkbox';
import { Button, FormControlLabel, Stack } from '@mui/material';
import { secondsToMilliseconds } from 'date-fns/esm';
import AutoScrollOptionsPopup, { AutoScrollSettings } from './AutoScrollOptionsPopup';

function Display() {
  const storageKeyTeam = 'displayTeam';
  const storageKeyRoles = 'displayRoles';
  const storageKeyProxy = 'displayProxy';
  const [filters, setFilters] = useState<IFilterOptions>({
    team: getStoredSelection(storageKeyTeam),
    roles: getStoredSelection(storageKeyRoles),
    proxy: getStoredProxySelection(storageKeyProxy),
  });
  const [isAutoScrollOptionsOpen, setIsAutoScrollOptionsOpen] = useState<boolean>(false);
  const [autoScrollSettings, setAutoScrollSettings] = useState<AutoScrollSettings>(getStoredAutoScrollSettings);

  const { data: priorities, isLoading } = PriorityQueries().FetchPrioritiesByTeam(
    filters.proxy,
    filters.team?.value,
    undefined,
    undefined,
    SelectedRoles(filters.roles),
    6000
  );

  useEffect(() => {
    const interval = setInterval(() => {
      if (autoScrollSettings.autoScrollEnabled) {
        const isBottomOfPage = window.innerHeight + window.pageYOffset >= document.body.offsetHeight;

        if (isBottomOfPage) {
          scroll.scrollToTop();
        } else {
          scroll.scrollMore(autoScrollSettings.scrollIncrement);
        }
      } else {
        clearInterval(interval);
      }
    }, secondsToMilliseconds(autoScrollSettings.scrollDelay));

    return () => {
      clearInterval(interval);
    };
  }, [autoScrollSettings]);

  const renderPriorities = () => {
    if (isLoading) {
      return <Loading />;
    }

    if (!priorities || priorities.length === 0) {
      return <div>No Priorities to Display</div>;
    }

    return priorities.map(employee => <EmployeeDisplayGrid employee={employee} key={employee.id} />);
  };

  return (
    <>
      <AutoScrollOptionsPopup
        isOpen={isAutoScrollOptionsOpen}
        setIsOpen={setIsAutoScrollOptionsOpen}
        autoScrollSettings={autoScrollSettings}
        setAutoScrollSettings={setAutoScrollSettings}
      />
      <Stack direction="row" spacing={1} sx={{ padding: 1, marginTop: -5, width: '100%', justifyContent: 'end' }}>
        <Button variant="text" onClick={() => setIsAutoScrollOptionsOpen(true)}>
          Auto Scroll Settings
        </Button>

        <FormControlLabel
          label="Auto Scroll"
          control={
            <Checkbox
              onChange={e => {
                const updatedAutoScrollSettings = {
                  ...autoScrollSettings,
                  autoScrollEnabled: e.target.checked,
                };
                storeAutoScrollSettinga(updatedAutoScrollSettings);
                setAutoScrollSettings(updatedAutoScrollSettings);
              }}
              checked={autoScrollSettings.autoScrollEnabled}
            />
          }
        />
      </Stack>

      <FilterOptions state={filters} setState={setFilters} page={'display'} />
      {renderPriorities()}
    </>
  );
}

export default Display;
